<template>
    <div>
        <div v-padding="3">
            <v-row>
                <v-col xs="6">
                    <v-form @submit="handleSubmit" :validate="validate" :readonly="isSearching">
                        <template scope="api">
                            <v-form-input v-if="isIndividual" v-margin.bottom="2" field="lastName" label="Фамилия" />
                            <v-form-input v-if="isIndividual" v-margin.bottom="2" field="firstName" label="Имя" />
                            <v-form-input v-if="isIndividual" v-margin.bottom="2" field="middleName" label="Отчество" />

                            <v-form-input v-if="!isIndividual" v-margin.bottom="2" field="orgName" label="Название организации" />

                            <v-button type="submit" primary :disabled="api.isInvalid || isSearching">
                                найти
                            </v-button>
                        </template>
                    </v-form>
                </v-col>
            </v-row>
        </div>

        <request-table-inns v-if="isShowTable" v-model="selectedEntity" :is-individual="isIndividual">
            <v-font-icon grey>error</v-font-icon>

            <v-text v-margin.left="1" v-margin.right="4">Итого: {{ total }}</v-text>

            <v-spinner :active="isCreating">
                <v-button primary :disabled="!selectedEntity || isCreating" @click="handleCreateRequest">
                    выполнить запрос
                </v-button>
            </v-spinner>
        </request-table-inns>
    </div>
</template>

<script>
    import { validate, isRequired, isCyrillicFio } from '../../../services/validator';
    import { RequestTableInns } from '../requestTableInns';

    const individualRules = {
        firstName: [isRequired, isCyrillicFio],
        lastName: [isRequired, isCyrillicFio],
        middleName: [isRequired, isCyrillicFio],
    };

    const companyRules = {
        orgName: [isRequired],
    };

    export default {
        name: 'search-form',
        props: {
            onCreate: Function,
            isIndividual: Boolean,
            isSearching: Boolean,
            total: {
                type: Number,
                default: 0,
            }
        },
        components: {
            RequestTableInns
        },
        data() {
            return {
                formValues: {},
                isCreating: false,
                isShowTable: false,
                selectedEntity: undefined,
            }
        },
        watch: {
            isSearching(newValue) {
                if (newValue && !this.isShowTable) {
                    this.isShowTable = true;
                }
            }
        },
        methods: {
            validate(values) {
                return validate(values, this.isIndividual ? individualRules : companyRules);
            },

            handleSubmit(values) {
                this.formValues = values;
                this.selectedEntity = undefined;
                this.$emit('search', values)
            },

            handleCreateRequest() {
                this.isCreating = true;

                const fields = {
                    ...this.formValues,
                    [this.isIndividual ? 'ipInn':'orgInnAndOgrn']: this.selectedEntity.inn,
                };

                this.onCreate({ fields })
                    .then((res) => {
                        this.$router.push({ name: 'requests' });
                    })
                    .catch((res) => {
                        this.isCreating = false;
                    });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// SearchForm.vue?7ad8985a